module.exports = __webpack_public_path__ + "img/badge_software_silver.a654146a.png";